import { cn } from '@/lib/utils';

/**
 * Infinite horizontal ticker -- CSS-driven (not framer) so the loop stays
 * perfectly smooth regardless of React render cost, and pauses on hover via
 * plain :hover so there's no JS in the hot path. Respects
 * prefers-reduced-motion globally via the .marquee-track rule in index.css.
 *
 * Usage: <Marquee><span>Item</span><span>Item</span>...</Marquee>
 * Children are duplicated once to create the seamless loop -- pass a stable
 * array, not something regenerated every render.
 */
const Marquee = ({ children, speed = 28, reverse = false, className, itemClassName }) => (
  <div className={cn('marquee-viewport', className)}>
    <div
      className="marquee-track"
      style={{
        animationDuration: `${speed}s`,
        animationDirection: reverse ? 'reverse' : 'normal',
      }}
    >
      {[0, 1].map((copy) => (
        <div className="marquee-group" key={copy} aria-hidden={copy === 1}>
          {Array.isArray(children)
            ? children.map((child, i) => (
                <span className={cn('marquee-item', itemClassName)} key={i}>
                  {child}
                </span>
              ))
            : <span className={cn('marquee-item', itemClassName)}>{children}</span>}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
